import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { NgxSmartModalComponent } from 'ngx-smart-modal';
import { SubscriptionService } from '../../core/subscription/subscription.service';
import { UserService } from '../../core/user/user.service';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'rosie-pause-subscription-modal',
  templateUrl: './pause-subscription-modal.component.html',
  styleUrls: ['./pause-subscription-modal.component.scss'],
  standalone: false
})
export class PauseSubscriptionModalComponent {
  @ViewChild('pauseSubscriptionModal') modal: NgxSmartModalComponent;
  @Output() paused = new EventEmitter<void>();

  isPausing = false;

  constructor(
    private subscription: SubscriptionService,
    private user: UserService,
    private messageService: MessageService
  ) {}

  open(): void {
    this.isPausing = false;
    this.modal.open();
  }

  close(): void {
    this.modal.close();
  }

  pause(): void {
    if (this.isPausing) return;

    const subscriptionId = this.user.userData?.subscription?.id;
    if (!subscriptionId) return;

    this.isPausing = true;
    this.subscription.pauseSubscription(subscriptionId).subscribe({
      next: () => {
        this.isPausing = false;
        this.messageService.add({
          severity: 'success',
          detail: 'Your subscription has been paused.',
          life: 3000
        });
        this.paused.emit();
        this.close();
      },
      error: (err) => {
        this.isPausing = false;
        const detail = (typeof err === 'string' ? err : null) || 'Failed to pause subscription. Please try again.';
        this.messageService.add({
          severity: 'error',
          detail,
          life: 5000
        });
      }
    });
  }
}
